import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "os-chevron.right",
  "use": "os-chevron.right-usage",
  "viewBox": "0 0 9.551 16.963",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9.551 16.963\" id=\"os-chevron.right\"><path d=\"M9.55 8.477q0-.186-.072-.347-.074-.161-.21-.298L1.533.254Q1.27 0 .89 0q-.244 0-.45.117Q.234.234.117.435 0 .635 0 .889q0 .361.254.634l7.11 6.954-7.11 6.953Q0 15.703 0 16.064q0 .254.117.455.117.2.322.317.206.117.45.117.38 0 .644-.264l7.735-7.568q.136-.137.21-.298.073-.16.073-.346z\" fill=\"rgba(255,255,255,0.85)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol